import { render, staticRenderFns } from "./KeywordsPage.vue?vue&type=template&id=282c7e24&scoped=true&"
import script from "./KeywordsPage.vue?vue&type=script&lang=js&"
export * from "./KeywordsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282c7e24",
  null
  
)

export default component.exports